import { render, staticRenderFns } from "./UserEditPage.vue?vue&type=template&id=377faf5a"
import script from "./user_edit.js?vue&type=script&lang=js&external"
export * from "./user_edit.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports